module.exports = __webpack_public_path__ + "img/tile-keyframes-desktop_cn.90d98e2.jpg";